import {
  clearSrDocumentSubtypeAction,
  clearSrDocumentSubtypeErrors,
  updateSrDocumentSubtype,
} from 'actions/srDocuments/srDocumentSubtypeActions'
import {
  clearSrDocumentTypeOptions,
  fetchSrDocumentTypes,
} from 'actions/srDocuments/srDocumentTypeActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const SrDocumentSubtypeUpdate = ({
  formId,
  params,
  setParams,
  closeModal,
  selected,
  setSelected,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { typeOptions } = useSelector((state) => state.srDocumentTypes)
  const { lastAction, subtypeErrors } = useSelector(
    (state) => state.srDocumentSubtypes
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    dispatch(fetchSrDocumentTypes('form', selected.sr_document_type, true))
    return () => {
      dispatch(clearSrDocumentTypeOptions())
      dispatch(clearSrDocumentSubtypeAction())
      dispatch(clearSrDocumentSubtypeErrors())
    }
  }, [dispatch, selected.sr_document_type])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        id: selected.id,
        name: selected.name,
        sr_document_type_id: selected.sr_document_type.id,
      })
    }
  }, [params, setParams, selected])

  useEffect(() => {
    if (lastAction === 'edit') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) || !typeOptions.length ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(updateSrDocumentSubtype(params, selected))
      }}
      className="form container"
      noValidate
    >
      <AdminForm
        params={params}
        setParams={setParams}
        selected={selected}
        setSelected={setSelected}
        srDocumentTypes={typeOptions}
        errors={subtypeErrors}
      />
    </form>
  )
}

export default SrDocumentSubtypeUpdate
